import { atom } from "recoil";
import { PubDetail } from "../api/cafe";

export const pubState = atom<PubDetail | null>({
  key: "pub",
  default: null,
});
